import type { Assembler } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleAssemblerQueryResult {
  assembler: Assembler
}

export interface SingleAssemblerQueryVariables {
  id?: GQL_ID
}

const GQL_QUERY_SINGLE_ASSEMBLER = gql`
  query (
    $id: ID!
  ) {
    assembler: singleAssembler(
      id: $id
    ) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      shop {
        id
        name
      }
      role
    }
  }
`

export const useFetchSingleAssembler = (
  variables: SingleAssemblerQueryVariables
) =>
  useQuery<SingleAssemblerQueryResult, SingleAssemblerQueryVariables>(
    GQL_QUERY_SINGLE_ASSEMBLER,
    { variables, skip: !variables.id }
  )
